module.exports = __webpack_public_path__ + "static/case-list-96cb38dad73c8884a790535c52b1d78d.png";